import { render, staticRenderFns } from "./SowTypeTableRow.vue?vue&type=template&id=72497aef"
import script from "./SowTypeTableRow.vue?vue&type=script&lang=js"
export * from "./SowTypeTableRow.vue?vue&type=script&lang=js"
import style0 from "./SowTypeTableRow.vue?vue&type=style&index=0&id=72497aef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports